const LogoHorizontal = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="30"
    fill="none"
    viewBox="0 0 984 108"
  >
    <mask
      id="mask0_166_139"
      style={{ maskType: "alpha" }}
      width="984"
      height="108"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="#171717"
        fillRule="evenodd"
        d="M235.03 96.35h17.654v-2.278L216.25 16h-7.849l-36.668 78.072v2.278h17.758l22.77-53.834L235.03 96.35zM278.55 16h-17.227v80.337h17.227V16zm3.523 80.337h30.01v-15.38h-30.01v15.38zM381.312 96.35h17.654v-2.278L362.531 16h-7.849l-36.667 78.072v2.278h17.77l22.757-53.834 22.77 53.834zM452.924 67.141c9.17-4.466 14.325-13.4 14.325-23.59 0-14.202-9.973-27.486-28.3-27.486-11.463-.117-22.809 0-34.259 0v80.182h16.955V31.083h17.187c7.331 0 11.8 5.386 11.8 12.145.116 6.875-4.585 12.481-11.8 12.481h-13.664v14.087h11.035l16.501 26.464h18.327v-2.408l-18.107-26.685v-.026zM516.649 54.117L484.476 16h-6.295v80.35h17.174V52.977l20.154 25.17h2.176l20.14-25.17V96.35H555V16h-6.178l-32.173 38.117z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#171717"
        fillRule="evenodd"
        d="M201.225 83.26h21.967l-10.983-12.998-10.984 12.999zM347.507 83.26h21.967L358.49 70.263 347.507 83.26zM61.5 0l10.978 19.286-39.892 70.056h13.808l32.994-57.93L123 108H67.975L78.6 89.343h11.76L79.43 70.15 57.875 108H0L61.5 0zM688.735 48.798l-7.357-14.954-9.714-16.624h-17.977v2.46l26.901 44.409v31.255h16.747V64.089l26.798-44.409v-2.46h-17.757l-9.377 16.068-7.694 15.51h-.57zM803.698 31.734h36.953V17.22h-57.832v14.514h20.879zm0 3.418v60.192h16.19V35.152h-16.19zM898.197 17.22H850.3v78.124h48.791V80.169h-31.927V62.302h22.057V47.685h-22.057V31.837h31.033V17.22zM945.9 54.158L914.53 17h-6.14v78.344h16.747V53.045l19.649 24.548h2.111l19.648-24.548v42.299h16.748V17h-6.023L945.9 54.158zM600.026 83.911l8.846-10.008c1.114 2.745 2.914 4.907 5.375 6.46 2.474 1.58 5.259 2.37 8.342 2.37 3.73 0 6.683-.88 8.846-2.654 2.163-1.748 3.238-4.13 3.238-7.108 0-3.522-3.614-7.018-10.828-10.5-2.344-1.127-4.184-2.033-5.531-2.745-6.502-3.392-11.009-6.707-13.522-9.93-2.499-3.237-3.743-7.096-3.743-11.563 0-6.124 2.422-11.16 7.279-15.096 4.857-3.949 11.165-5.93 18.923-5.93 4.508 0 8.393.803 11.67 2.37 3.264 1.553 6.152 4.039 8.652 7.38l-9.403 8.985c-1.114-2.162-2.603-3.78-4.443-4.843-1.852-1.074-4.08-1.618-6.67-1.618-3.16 0-5.686.803-7.629 2.37-1.93 1.553-2.901 3.612-2.901 6.123 0 3.924 3.834 7.51 11.475 10.773 1.529.647 2.707 1.139 3.498 1.527 6.307 2.875 10.983 6.124 14.014 9.75 3.018 3.625 4.546 7.755 4.546 12.39 0 6.966-2.37 12.533-7.15 16.676-4.753 4.156-11.151 6.228-19.182 6.228-5.686 0-10.556-.971-14.636-2.952-4.054-1.955-7.097-4.79-9.092-8.48l.026.025zM726.244 83.911l8.847-10.008c1.114 2.745 2.914 4.907 5.375 6.46 2.474 1.58 5.258 2.37 8.341 2.37 3.73 0 6.683-.88 8.846-2.654 2.163-1.748 3.238-4.13 3.238-7.108 0-3.522-3.613-7.018-10.828-10.5-2.344-1.127-4.183-2.033-5.53-2.745-6.502-3.392-11.009-6.707-13.522-9.93-2.5-3.237-3.743-7.096-3.743-11.563 0-6.124 2.422-11.16 7.279-15.096 4.857-3.949 11.165-5.93 18.923-5.93 4.507 0 8.393.803 11.67 2.37 3.264 1.553 6.152 4.039 8.652 7.38l-9.403 8.985c-1.114-2.162-2.604-3.78-4.443-4.843-1.852-1.074-4.08-1.618-6.683-1.618-3.161 0-5.686.803-7.629 2.37-1.93 1.553-2.901 3.612-2.901 6.123 0 3.924 3.833 7.51 11.475 10.773 1.528.647 2.707 1.139 3.497 1.527 6.308 2.875 10.984 6.124 14.014 9.75 3.018 3.625 4.547 7.755 4.547 12.39 0 6.966-2.371 12.533-7.15 16.676-4.753 4.156-11.152 6.228-19.182 6.228-5.686 0-10.556-.971-14.636-2.952-4.054-1.955-7.098-4.79-9.092-8.48l.038.025z"
        clipRule="evenodd"
      ></path>
    </mask>
    <g mask="url(#mask0_166_139)">
      <rect
        width="1029"
        height="126"
        x="-18"
        y="-7"
        fill="url(#paint0_linear_166_139)"
        rx="4"
      ></rect>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_166_139"
        x1="496.5"
        x2="496.5"
        y1="-7"
        y2="119"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#549FCF"></stop>
        <stop offset="1" stopColor="#124B93"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default LogoHorizontal;
